@if (initialized) {
  <form [formGroup]="inputForm">
    <div class="container">
      <!-- Msg -->
      @if (materialTestReport.id) {
        <section>
          <div class="report-header">
            <div>
              <div class="mat-body">Uploaded by {{materialTestReport.createdBy?.name || 'the lab'}}</div>
              <div class="mat-caption">{{materialTestReport.created_at | dateFormat : 'MMMM DD, k:mm A'}}</div>
            </div>
            @if (resultBadge) {
              <div class="result-badge" [ngClass]="resultBadge.class">{{ resultBadge.label }}</div>
            }
          </div>
        </section>
      }
      <!-- Attachments section -->
      <section>
        <div class="mat-body-2">Attachments:</div>
        <div class="preview-list">
          <app-file-uploader class="input-placeholder small" [disabled]="!editing" [multiple]="true" icon="attach_file" accept="image/*"
            (complete)="onUploadComplete($event)">
          </app-file-uploader>
          @for (att of materialTestReport.attachments; track att) {
            <div>
              <img [src]="att.getThumbnail()" class="link"
                (click)="appSrv.openCarousel($event, materialTestReport.attachments, att)" />
              @if (editing) {
                <button mat-icon-button aria-label="Delete" title="Delete" class="hover-icon"
                  (click)="removeAttachment(att)">
                  <mat-icon>delete</mat-icon>
                </button>
              }
            </div>
          }
        </div>
        @if (inputForm.controls.attachments.hasError('error')) {
          <mat-error>
            {{inputForm.controls.attachments.errors.error}}
          </mat-error>
        }
      </section>
      <!-- /Attachments section -->
      <!-- Comment section -->
      <section>
        <div class="mat-body-2">Report note:</div>
        @if (!editing) {
          <div class="mat-body">{{materialTestReport.comment}}</div>
        }
        @if (editing) {
          <mat-form-field>
            <textarea matInput formControlName="comment" [errorStateMatcher]="matcher"></textarea>
            @if (inputForm.controls.comment.hasError('required')) {
              <mat-error>
                This field is <strong>required</strong>
              </mat-error>
            }
            @if (inputForm.controls.comment.hasError('error')) {
              <mat-error>
                {{inputForm.controls.comment.errors.error}}
              </mat-error>
            }
          </mat-form-field>
        }
      </section>
      <!-- /Comment section -->
      <!-- Form Actions -->
      <section>
        @if (editing) {
          <div class="row">
            <button mat-stroked-button color="accent" (click)="saveItem()">Upload report</button>
          </div>
        }
      </section>
      <!-- Form Actions -->
    </div>
  </form>
}
